import { t, currentLanguage } from '../../../i18n/strings.js';
import { formatMoney } from '../../../lib/pricing.js';
import { fillTemplate } from '../../../lib/helpers.js';

// Equivalência por dia só quando a conta fecha: semana (÷7) e ano (÷365).
// Mês não tem nº fixo de dias → não mostra.
export default function PlanCard({ plan, selected, onSelect }) {
  const m = (v) => formatMoney(v, plan.currency, currentLanguage);
  const shown = plan.promoAmount ?? plan.amount;
  const showPerDay = plan.interval === 'week' || plan.interval === 'year';
  const badges = [];
  if (plan.badge === 'popular') badges.push({ text: t('paywallIntl.badgePopular'), solid: true });
  if (plan.badge === 'best') badges.push({ text: t('paywallIntl.badgeBest'), solid: true });
  if (plan.discountPct) badges.push({ text: fillTemplate(t('paywallIntl.badgeOff'), { pct: plan.discountPct }), solid: false });

  return (
    <button
      type="button"
      role="radio"
      aria-checked={selected}
      onClick={onSelect}
      className={`w-full text-left rounded-[20px] border-2 p-4 transition-all ${
        selected ? 'border-cyan bg-cyan/5' : 'border-white/10 bg-surface'
      }`}
      style={selected ? { boxShadow: '0 0 0 1px rgba(25,215,242,0.25), 0 0 24px rgba(25,215,242,0.22)' } : undefined}
    >
      {badges.length > 0 && (
        <div className="flex flex-wrap gap-1.5 mb-2">
          {badges.map((b) => (
            <span
              key={b.text}
              className={`text-[11px] font-bold px-2.5 py-1 rounded-full ${b.solid ? 'bg-cyan text-bg' : 'bg-cyan/15 text-cyan'}`}
            >
              {b.text}
            </span>
          ))}
        </div>
      )}
      <div className="flex items-center justify-between gap-3">
        <div className="flex items-center gap-3 min-w-0">
          <div
            className={`w-5 h-5 rounded-full border-2 flex items-center justify-center shrink-0 ${
              selected ? 'border-cyan' : 'border-ink-muted'
            }`}
          >
            {selected && <div className="w-2.5 h-2.5 rounded-full bg-cyan" />}
          </div>
          <div className="min-w-0">
            <div className="font-display font-bold text-[16px]">{t(`paywallIntl.plan_${plan.interval}`)}</div>
            {showPerDay && (
              <div className="text-[12px] text-ink-muted">
                {fillTemplate(t('paywallIntl.perDayEq'), { price: m(plan.perDayAmount) })}
              </div>
            )}
          </div>
        </div>
        <div className="text-right shrink-0">
          {plan.promoAmount != null && <div className="text-ink-muted line-through text-xs">{m(plan.amount)}</div>}
          <div className="font-display font-extrabold text-[22px] leading-tight">{m(shown)}</div>
          <div className="text-[11px] text-ink-muted">{t(`paywallIntl.per${plan.interval === 'week' ? 'Week' : plan.interval === 'month' ? 'Month' : 'Year'}Short`)}</div>
        </div>
      </div>
    </button>
  );
}
